// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + "lazysizes" + "." + "9aa3e16b9faf5b691bee" + ".chunks.js";
};